/**
 * ACCounselling (Care/Counselling Management) Services Module
 * Exports all care management services and factory functions
 */
// Export all service classes
export { CareCaseService } from './CareCaseService';
export { CareSessionService } from './CareSessionService';
export { LeaderService } from './LeaderService';
export { AccounsellingStreamingService } from './AccounsellingStreamingService';
export { CareRequestService } from './CareRequestService';
export { CareAreaService } from './CareAreaService';
export { CareNeedService } from './CareNeedService';
export { NeedCustomFieldService } from './NeedCustomFieldService';
export { CareZoneService } from './CareZoneService';
export { LeaderTypeService } from './LeaderTypeService';
export { CareSessionTypeService } from './CareSessionTypeService';
export { CareCaseStatusService } from './CareCaseStatusService';
export { CareSessionStatusService } from './CareSessionStatusService';
export { CareRequestStatusService } from './CareRequestStatusService';
export { ACCareSettingService } from './ACCareSettingService';
export { ACCareNotificationChannelService } from './ACCareNotificationChannelService';
export { LeaderPortalService } from './LeaderPortalService';
export { PublicCareService } from './PublicCareService';
export { PublicCareRequestService } from './PublicCareRequestService';
// Import for factory function
import { CareCaseService } from './CareCaseService';
import { CareSessionService } from './CareSessionService';
import { LeaderService } from './LeaderService';
import { AccounsellingStreamingService } from './AccounsellingStreamingService';
import { CareRequestService } from './CareRequestService';
import { CareAreaService } from './CareAreaService';
import { CareNeedService } from './CareNeedService';
import { NeedCustomFieldService } from './NeedCustomFieldService';
import { CareZoneService } from './CareZoneService';
import { LeaderTypeService } from './LeaderTypeService';
import { CareSessionTypeService } from './CareSessionTypeService';
import { CareCaseStatusService } from './CareCaseStatusService';
import { CareSessionStatusService } from './CareSessionStatusService';
import { CareRequestStatusService } from './CareRequestStatusService';
import { ACCareSettingService } from './ACCareSettingService';
import { ACCareNotificationChannelService } from './ACCareNotificationChannelService';
import { LeaderPortalService } from './LeaderPortalService';
import { PublicCareService } from './PublicCareService';
import { PublicCareRequestService } from './PublicCareRequestService';
/**
 * Create all care management services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all care management service instances
 */
export function createACCounsellingServices(http, config) {
    return {
        careCase: new CareCaseService(http, config),
        careSession: new CareSessionService(http, config),
        leader: new LeaderService(http, config),
        careRequest: new CareRequestService(http, config),
        careArea: new CareAreaService(http, config),
        careNeed: new CareNeedService(http, config),
        needCustomField: new NeedCustomFieldService(http, config),
        careZone: new CareZoneService(http, config),
        leaderType: new LeaderTypeService(http, config),
        careSessionType: new CareSessionTypeService(http, config),
        careCaseStatus: new CareCaseStatusService(http, config),
        careSessionStatus: new CareSessionStatusService(http, config),
        careRequestStatus: new CareRequestStatusService(http, config),
        acCareSetting: new ACCareSettingService(http, config),
        acCareNotificationChannel: new ACCareNotificationChannelService(http, config),
        leaderPortal: new LeaderPortalService(http, config),
        publicCare: new PublicCareService(http, config),
        publicCareRequest: new PublicCareRequestService(http, config),
        accounsellingStreaming: new AccounsellingStreamingService(http),
    };
}
//# sourceMappingURL=index.js.map